/* eslint-disable no-unused-vars */
import {useEffect, useCallback} from "react";
import {BasicTable} from "components/Table";
import {useMemo, useState} from "react";
import {useHistory} from "react-router-dom";
import {usePrices} from "hooks/Doctor/Price";
import {convertToCurency} from "utils/converter";
import DOCTOR_PRICE_STATUS from "config/doctorPriceStatus";

export function DoctorPriceTable({hospitalId, search, hospitalName, onDataStatusChange, onEditRow}) {
	const history = useHistory();
	const [dataLimit, setDataLimit] = useState(10);
	const {data: schedules, isLoading: isLoadingPrices, filterPrices, setFilterPrices} = usePrices(hospitalId);

	const statusStyle = useCallback(status => {
		switch (status) {
			case DOCTOR_PRICE_STATUS.WAITING:
				return {
					backgroundColor: "#FFF7E1",
					color: "#FB9C18",
					cursor: "pointer",
					textDecoration: "underline",
				};
			case DOCTOR_PRICE_STATUS.APPROVED:
				return {
					backgroundColor: "#DFFFDA",
					color: "#39B50E",
				};
			default:
				return {
					backgroundColor: "#FFD8D8",
					color: "#F21A1A",
				};
		}
	}, []);

	useEffect(() => {
		setFilterPrices(prev => ({...prev, search}));
	}, [search, setFilterPrices]);

	const columnsPrice = useMemo(
		() => [
			{
				Header: "No",
				accessor: "idSerial",
			},
			{
				Header: "Harga",
				accessor: "price",
				Cell: ({row}) => {
					return <>Rp. {convertToCurency(`${row.original.consultationFee?.amount}` || "0")}</>;
				},
			},
			{
				Header: "Status",
				accessor: "status",
				Cell: ({row}) => (
					<span class={`px-4 py-2 rounded-3`} style={statusStyle(row?.original?.status)}>
						{row?.original?.status}
					</span>
				),
			},
			{
				Header: "Aksi",
				accessor: "id",
				Cell: ({row}) => (
					<>
						<a
							className="text-orange wait-pay disabled"
							style={{cursor: "pointer"}}
							onClick={() => {
								onEditRow(row.original);
							}}>
							<span className="icon-ico-pencil ft-18" />
						</a>
					</>
				),
			},
		],
		[],
	);

	const dataPriceWithIDSerial =
		schedules?.data?.rows?.map((item, index) => ({
			...item,
			idSerial: (schedules?.data?.currentPage - 1) * dataLimit + index + 1,
		})) || [];

	// kirim status ke parent
	useEffect(() => {
		if (onDataStatusChange) {
			onDataStatusChange(hospitalId, dataPriceWithIDSerial.length > 0);
		}
	}, [dataPriceWithIDSerial.length, hospitalId, onDataStatusChange]);

	if (dataPriceWithIDSerial?.length < 1) {
		return null;
	}

	return (
		<div className="box-white setting-content h-100 no-border rounded-5 overflow-hidden w-100 mb-4">
			<div
				className="d-flex flex-wrap justify-content-between align-items-center p-4"
				style={{backgroundColor: "#E2F7F7"}}>
				<div style={{color: "#45969B"}}>{hospitalName}</div>
			</div>

			<BasicTable
				columns={columnsPrice}
				currentPage={schedules?.data?.currentPage}
				data={dataPriceWithIDSerial}
				limit={dataLimit}
				loading={isLoadingPrices}
				striped={true}
				title="Data Jadwal Praktik"
				totalItems={schedules?.data?.totalItems}
				totalPage={schedules?.data?.totalPages}
				onLimitChange={limit => {
					setFilterPrices({...filterPrices, limit, page: 1, search: search});
					setDataLimit(limit);
				}}
				onPageChange={selectedPage =>
					setFilterPrices({
						...filterPrices,
						page: selectedPage,
						limit: dataLimit,
						search: search,
					})
				}
			/>
		</div>
	);
}
